// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductListTableLevel } from "@pacific/XDL/types";
import { NamedExoticComponent } from "react";

export const constants = {
    header: {
        size: {
            sticky: 90,
        },
        mobile: {
            size: {
                height: 156,
            },
        },
        tablet: {
            size: {
                height: 105,
            },
        },
    },
    footer: {
        offsetTop: 64,
    },
    searchInput: {
        breakpoints: {
            lg: 1280,
        },
    },
    cartLine: {
        breakpoints: {
            md: 1200,
            xs: "xs",
        },
    },
    productList: {
        xSortAndFilter: {
            screen: "isTabletScreen",
            breakpoint: "md",
        },
    },
    productGridView: {
        desktop: {
            width: 308,
            height: 308,
        },
        tablet: {
            width: 346,
            height: 230,
        },
        mobile: {
            width: 328,
            height: 280,
        },
    },
};

export const XNGAGE_CUSTOM_WIDGET = "Xngage Custom" as any;
export const EMPTY_VALUE = "- -";
export const DivWrapper = `div[class^="Wrapper"]`;
export const CartLinkZoneName = "Cart";
export const SignInZoneName = "SignIn";

interface AddToCartStatusInfoInterface {
    status: string;
    label: string;
    icon: NamedExoticComponent<{}> | string;
}
interface AddToCartStatusInterface {
    default: AddToCartStatusInfoInterface;
    loading: AddToCartStatusInfoInterface;
    success: AddToCartStatusInfoInterface;
}

export const addToCartStatus: AddToCartStatusInterface = {
    default: {
        status: "default",
        label: "Add to Cart",
        icon: "",
    },
    loading: {
        status: "loading",
        label: "",
        icon: "",
    },
    success: {
        status: "success",
        label: "Added",
        icon: "",
    },
};

export const SLIDES_PER_VIEW_POINTS = {
    xs: 0,
    sm: 1,
    md: 2,
    lg: 3,
};

export const checkoutPages = ["CheckoutShippingPage", "CheckoutReviewAndSubmitPage"];

export const sharedDateTimeOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export enum USER_ROLES {
    ADMIN = "Administrator",
    BUYER1 = "Buyer1",
    BUYER2 = "Buyer2",
    BUYER3 = "Buyer3",
    FINANCE = "Finance",
    REQUISITIONER = "Requisitioner",
}
